export interface TrendItem {
  rank: number;
  tag: string;
  heat: string;
  trend: "up" | "down" | "new" | "hot";
  hot: boolean;
}

export interface TrendPlatform {
  key: string;
  name: string;
  icon: string;
  tone: string;
  items: TrendItem[];
}

export const trendPlatforms: TrendPlatform[] = [
  {
    key: "weibo",
    name: "微博",
    icon: "ri-weibo-line",
    tone: "bg-accent-500",
    items: [
      { rank: 1, tag: "哇偶姐姐深夜直播回应", heat: "286.4万", trend: "hot", hot: true },
      { rank: 2, tag: "哇偶姐姐 旧照被扒", heat: "212.9万", trend: "up", hot: true },
      { rank: 3, tag: "哇偶姐姐 人设翻车了吗", heat: "168.3万", trend: "hot", hot: true },
      { rank: 4, tag: "哇偶姐姐机场生图", heat: "142.7万", trend: "new", hot: false },
      { rank: 5, tag: "哇偶姐姐 怼黑粉录音流出", heat: "98.6万", trend: "up", hot: false },
      { rank: 6, tag: "哇偶姐姐 合作方回应", heat: "76.2万", trend: "down", hot: false },
      { rank: 7, tag: "哇偶姐姐 澄清声明全文", heat: "61.5万", trend: "new", hot: false },
      { rank: 8, tag: "哇偶姐姐 评论区沦陷", heat: "45.9万", trend: "down", hot: false },
      { rank: 9, tag: "哇偶姐姐 十年老粉脱粉", heat: "32.4万", trend: "up", hot: false },
      { rank: 10, tag: "哇偶姐姐 业内人士爆料", heat: "21.8万", trend: "new", hot: false },
    ],
  },
  {
    key: "douyin",
    name: "抖音",
    icon: "ri-voiceprint-line",
    tone: "bg-primary-500",
    items: [
      { rank: 1, tag: "哇偶姐姐直播翻车回放", heat: "523万", trend: "hot", hot: true },
      { rank: 2, tag: "全网都在模仿哇偶姐姐", heat: "317万", trend: "up", hot: true },
      { rank: 3, tag: "哇偶姐姐滤镜前后对比", heat: "289万", trend: "new", hot: true },
      { rank: 4, tag: "爆笑！哇偶姐姐语录", heat: "174万", trend: "up", hot: false },
      { rank: 5, tag: "哇偶姐姐翻白眼合集", heat: "131万", trend: "new", hot: false },
      { rank: 6, tag: "吐槽哇偶姐姐的高能段子", heat: "97.3万", trend: "up", hot: false },
      { rank: 7, tag: "哇偶姐姐回应完整版", heat: "82.1万", trend: "down", hot: false },
      { rank: 8, tag: "博主逐帧分析哇偶姐姐", heat: "60.8万", trend: "new", hot: false },
    ],
  },
  {
    key: "xhs",
    name: "小红书",
    icon: "ri-pen-nib-line",
    tone: "bg-accent-600",
    items: [
      { rank: 1, tag: "理性讨论哇偶姐姐为什么被群嘲", heat: "35.2万", trend: "hot", hot: true },
      { rank: 2, tag: "哇偶姐姐同款穿搭避雷", heat: "28.7万", trend: "up", hot: true },
      { rank: 3, tag: "客观复盘哇偶姐姐争议始末", heat: "24.9万", trend: "hot", hot: true },
      { rank: 4, tag: "哇偶姐姐素人时期旧照考古", heat: "19.6万", trend: "new", hot: false },
      { rank: 5, tag: "不吹不黑 说说哇偶姐姐", heat: "15.3万", trend: "down", hot: false },
      { rank: 6, tag: "哇偶姐姐推荐的东西真的好吗", heat: "11.8万", trend: "up", hot: false },
      { rank: 7, tag: "如何正确吃哇偶姐姐的瓜", heat: "8.9万", trend: "new", hot: false },
    ],
  },
  {
    key: "tieba",
    name: "贴吧",
    icon: "ri-chat-1-line",
    tone: "bg-secondary-500",
    items: [
      { rank: 1, tag: "【集中讨论】哇偶姐姐这几天到底发生了什么", heat: "1.8万", trend: "hot", hot: true },
      { rank: 2, tag: "理性贴 哇偶姐姐人设是真的崩了吗", heat: "1.4万", trend: "up", hot: true },
      { rank: 3, tag: "哇偶姐姐黑历史大起底（持续更新）", heat: "1.2万", trend: "hot", hot: false },
      { rank: 4, tag: "考古考到真瓜，挺有意思", heat: "9600", trend: "new", hot: false },
      { rank: 5, tag: "吃瓜十年，第一次见这种操作", heat: "7300", trend: "down", hot: false },
      { rank: 6, tag: "理性路人说两句公道话", heat: "5100", trend: "up", hot: false },
    ],
  },
];